import DataTableX from 'components/DataTableX/DataTableX'
import React, { useState } from 'react'
import iconCuponesAutoservicio from './assets/icon-cupones-autoservicio.svg'
import iconGenerar from './assets/icon-generar.svg'
import { setearMiles } from 'util/funciones'
import { GetCupones } from './service/cupones-autoservicio.service'
import ButtonMenu from 'components/ButtonMenu/ButtonMenu'
import iconoInformacion from 'assets/images/datatable/informacion.svg'
import FiltroCupones from './components/FiltroCupones'
import "./styles/index.css"
import ModalCupon from './components/modal-cupon/ModalCupon'
import { Form, message } from 'antd'
import Storage from "util/store/Storage";

const INITIAL_STATE: any = {
     data: null,
     method: "CREATE"
}

enum ESTADOS_IDS {
     GENERADO_OFFLINE = 0,
     CONVERTIDO = 1
}

const CuponesAutoservicio = () => {
     const [form] = Form.useForm();
     const { empresasHijos } = Storage.getState()
     const [loading, setLoading] = useState(false)
     const [dataCupones, setDataCupones] = useState<any[]>([])
     const [method, setMethod] = useState<{
          data: any
          method: "CREATE" | "EDIT" | "VIEW"
     }>(INITIAL_STATE)

     const [openForm, setOpenForm] = useState(false)

     const handleSubmitFilter = async () => {
          setLoading(true)
          try {
               await form.validateFields();
               const formValues = await form.getFieldsValue();

               const params = {
                    fecha_inicio: formValues.fecha_range[0].format("YYYY-MM-DD"),
                    fecha_fin: formValues.fecha_range[1].format("YYYY-MM-DD"),
                    estaciones: formValues.estaciones?.includes(0) ? empresasHijos : formValues.estaciones.join(","),
                    estado_cupo_id: formValues.estado_cupo_id,
               }

               const { data } = await GetCupones(params);
               setDataCupones(data.body ?? []);
          } catch (error) {
               console.log("Error en la validación del formulario:", error);
               message.error("Por favor, complete los campos requeridos.");
          } finally {
               setLoading(false)
          }
     }

     const onCancelForm = (isChange = false) => {
          setOpenForm(false)
          setMethod(INITIAL_STATE)

          if (isChange) {
               setLoading(true)
               handleSubmitFilter()
                    .finally(() => setLoading(false))
          }
     }

     const handlerFormState = (field: "data" | "method", value: any) => setMethod((prev: any) => ({ ...prev, [field]: value }))

     const renderButtonMenu = (record: any) => {
          return [
               {
                    label: 'Generar',
                    icon: <img src={iconGenerar} />,
                    onClick: () => {
                         handlerFormState('method', 'EDIT')
                         handlerFormState('data', record)
                         setOpenForm(true)
                    },
                    disabled: record.es_generado
               },
               {
                    label: 'Información',
                    icon: <img src={iconoInformacion} />,
                    onClick: () => {
                         handlerFormState('method', 'VIEW')
                         handlerFormState('data', record)
                         setOpenForm(true)
                    },
                    disabled: !record.es_generado
               },

          ]
     }

     const COLUMNS_CUPONES_AUTOSERVICIO: any = [
          {
               dataIndex: 'estacion',
               align: 'center',
               title: 'Estación'
          },
          {
               dataIndex: 'cliente',
               align: 'center',
               title: 'Cliente'
          },
          {
               dataIndex: 'valor',
               align: 'center',
               title: 'Valor',
               render: (value: any, _: any) => <span>${setearMiles(value)}</span>
          },
          {
               dataIndex: 'producto',
               align: 'center',
               title: 'Producto',
               render: (value: any, _: any) => `${value.toUpperCase()}`
          },
          {
               dataIndex: 'estado',
               align: 'center',
               title: 'Estado',
               render: (value: any, _: any) => `${value.toUpperCase()}`
          },
          {
               dataIndex: 'fecha_generacion',
               align: 'center',
               title: 'Fecha generación'
          },
          {
               dataIndex: 'fecha_vigencia',
               align: 'center',
               title: 'Fecha vigencia'
          },
          {
               dataIndex: 'origen',
               align: 'center',
               title: 'Origen'
          },
          {
               dataIndex: 'acciones',
               align: 'center',
               title: 'Acciones',
               render: (_: any, record: any) =>
                    <section style={{
                         width: '100%',
                         display: 'flex',
                         justifyContent: 'center'
                    }} className='w-100'>
                         {<ButtonMenu itemsMenu={renderButtonMenu(record)} />}
                    </section >
          }
     ]

     return (
          <div>
               <ModalCupon
                    open={openForm}
                    onCancel={onCancelForm}
                    method={method.method}
                    data={method.data}
               />

               <DataTableX
                    iconTable={<img src={iconCuponesAutoservicio} alt="icono" className='icon-table' />}
                    titleTable='Cupones autoservicio'
                    nameReport='cupones_autoservicio'
                    loadingTable={loading}
                    data={dataCupones}
                    columns={COLUMNS_CUPONES_AUTOSERVICIO}
                    filterOptions={<FiltroCupones handleFilter={handleSubmitFilter} form={form} />}
               // showSearch={false}
               />
          </div>
     )
}

export default CuponesAutoservicio